export const MenuStyles = {
  home: 'homepage',
  solutions: 'solutions',
  audienceReach: 'audience_reach',
  insights: 'insights',
  caseStudies: 'case_studies',
  about: 'about_us',
  contact: 'contact',
}

export const insightsPageSize = 15
export const caseStudiesPageSize = 20
export const teamsPageSize = 2000